/**
 * Notes d'une précommande : la partie écrite par le vendeur, sans les mentions
 * que le logiciel compose lui-même.
 *
 * `buildNotes()` (PreorderCreateModal) préfixe la note libre d'une mention
 * « Pain coupe : … » calculée depuis les articles cochés « coupé ». En
 * rechargeant la note COMPLÈTE dans le champ libre (Reconduire, Modifier), la
 * mention revenait comme du texte saisi et une nouvelle s'ajoutait devant : une
 * couche de plus à chaque reconduction, jusqu'à neuf répétitions sur un ticket
 * (nettoyage du 10/10/2026, 22 précommandes). L'information « coupé » vit dans
 * les articles (`prep_options`) : la retirer de la note ne perd rien.
 */
const MENTION_AUTO = /^pain coup[eé]\s*:/i;

export function noteLibre(notes: string | null | undefined): string {
  if (!notes) return '';
  return notes
    .split('|')
    .map((s) => s.trim())
    .filter((s) => s.length > 0 && !MENTION_AUTO.test(s))
    .join(' | ');
}

/**
 * Le pain était-il coupé d'après la mention automatique de la note ? Filet
 * pour les précommandes d'avant `prep_options` : la mention « Pain coupe :
 * Pain gris, Baguette » nomme les articles coupés.
 */
export function estCoupeDansNote(notes: string | null | undefined, nomProduit: string): boolean {
  if (!notes || !nomProduit) return false;
  const plier = (t: string) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  const cible = plier(nomProduit);
  return notes
    .split('|')
    .map((s) => s.trim())
    .filter((s) => MENTION_AUTO.test(s))
    .some((s) => s.replace(MENTION_AUTO, '').split(',').map(plier).some((n) => n && (n === cible || cible.includes(n))));
}
